exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Video__Video__2cK1m {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n  -o-object-position: center;\n     object-position: center; }\n  .Video__Video__2cK1m video {\n    -o-object-fit: cover;\n       object-fit: cover; }\n  .Video__Video-wrapper__24hT_ {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden; }\n  .Video__Video__layer__19o8t {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.15); }\n", ""]);

// exports
exports.locals = {
	"Video": "Video__Video__2cK1m",
	"Video-wrapper": "Video__Video-wrapper__24hT_",
	"Video__layer": "Video__Video__layer__19o8t"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/home/circleci/project/src/styles"]}!./src/app/intro/components/Video/Video.scss
// module id = 534
// module chunks = 0